import { useState, useEffect } from "react";
import useAuthStore from "../../../store/authStore";
import { fetcher } from "../../../utils/fetcher";
import "./LinkExistingListModal.scss";

function LinkExistingListModal({ onSelect, onClose }) {
  const [projectLists, setProjectLists] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const currentProject = useAuthStore((state) => state.currentProject);

  useEffect(() => {
    const fetchLists = async () => {
      setIsLoading(true);
      try {
        // Only fetch project lists
        const projectData = currentProject?._id
          ? await fetcher.get(`/api/todolists/project/${currentProject._id}`)
          : [];

        setProjectLists(projectData || []);
      } catch (err) {
        console.error("Error fetching lists:", err);
        setProjectLists([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLists();
  }, [currentProject?._id]);

  // Filter lists based on search query
  const filteredProjectLists = projectLists.filter((list) =>
    list.title.toLowerCase().includes(searchQuery.toLowerCase()),
  );

  const handleListClick = (list) => {
    if (onSelect) {
      onSelect(list);
    }
    onClose();
  };

  const getListIcon = (type) => {
    return type === "checklist" ? "checklist" : "list";
  };

  return (
    <div className="link-existing-list-modal">
      <div className="search-container">
        <input
          type="text"
          className="search-input"
          placeholder="Search lists..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          autoFocus
        />
        <span className="material-symbols-outlined search-icon">search</span>
      </div>

      <div className="lists-container">
        {isLoading ? (
          <div className="loading-state">Loading lists...</div>
        ) : filteredProjectLists.length === 0 ? (
          <div className="empty-state">
            {searchQuery
              ? "No lists match your search"
              : "No project lists found"}
          </div>
        ) : (
          <div className="list-group">
            <div className="list-group-header">
              <span className="material-symbols-outlined">folder</span>
              <span className="list-group-title">Project Lists</span>
              <span className="list-group-count">
                ({filteredProjectLists.length})
              </span>
            </div>
            <div className="list-group-items">
              {filteredProjectLists.map((list) => (
                <div
                  key={list._id}
                  className="list-item"
                  onClick={() => handleListClick(list)}
                  style={{ "--list-color": list.color }}
                >
                  <span
                    className="material-symbols-outlined list-icon"
                    style={{ color: list.color }}
                  >
                    {getListIcon(list.type)}
                  </span>
                  <div className="list-info">
                    <span className="list-title">{list.title}</span>
                    <span className="list-meta">
                      {list.items?.length || 0} items • {list.type}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default LinkExistingListModal;
